import { LoadingButton } from '@mui/lab'
import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useContent, useUserCompleteTask } from '../../../../logic'
import { useOptimisticUpdateNotificationAndOrderNotification } from '../../../../logic/optimisticUpdates'
import { useGetOrder, useGetPayloadMetaData } from '../../../../logic/useApiQuery'
import { getTransactionsTotal } from '../../../../utils/getTransactionsTotal'
import { isAdhocPortalOrder } from '../../../../utils/isAdhocPortalOrder'
import { CompletePayloadTaskAmountRemainingDialog } from '../../dialogs/CompletePayloadTaskAmountRemainingDialog'
import { CompletePayloadTaskNoAmountRemainingDialog } from '../../dialogs/CompletePayloadTaskNoAmountRemainingDialog'
import { CompletePayloadTaskNoAmountSpecified } from '../../dialogs/CompletePayloadTaskNoAmountSpecified'
import { CashToCloseForm } from './CashToCloseForm'

export function CashToCloseEnterMoreOrComplete() {
  const { closingId, id } = useParams()
  const { search } = useLocation()
  const { TaskText } = useContent()

  const { mutate: mutateUserCompleteTask  } = useUserCompleteTask(closingId ?? '', id ?? '', search, {})
  const { optimisticUpdateNotificationAndOrderNotification } = useOptimisticUpdateNotificationAndOrderNotification()
  const { data: transactions } = useGetPayloadMetaData(closingId ?? '', id ?? '', search ?? '')
  const { data: orderData } = useGetOrder(closingId ?? '', search ?? '')
  const [payloadCompleteAmountRemainingOpen, setPayloadCompleteAmountRemainingOpen] = useState(false)
  const [payloadCompleteNoAmountRemainingOpen, setPayloadCompleteNoAmountRemainingOpen] = useState(false)
  const [payloadCompleteNoAmountSpecifiedOpen, setPayloadCompleteNoAmountSpecifiedOpen] = useState(false)

  const onUserCompleteTask = () => {
    optimisticUpdateNotificationAndOrderNotification({ orderKey: closingId ?? '', notificationId: id ?? '', search, patch: { IsComplete: true }})
    mutateUserCompleteTask(undefined)
  }

  const cashToClosePaid = orderData && !isAdhocPortalOrder(orderData?.Order) && (Number(orderData?.Order.CashToCloseDetails?.amount) - getTransactionsTotal(transactions) <= 0)
  const cashToCloseAmountExists = orderData && !isAdhocPortalOrder(orderData?.Order) && !!orderData?.Order.CashToCloseDetails?.amount && Number(orderData?.Order.CashToCloseDetails?.amount) > 0

  useEffect(() => {
    if (cashToClosePaid && cashToCloseAmountExists) setPayloadCompleteNoAmountRemainingOpen(true)
  }, [cashToClosePaid, cashToCloseAmountExists])

  const onUserSelfCompleteTask = () => {
    if (!cashToCloseAmountExists) {
      setPayloadCompleteNoAmountSpecifiedOpen(true)
    } else if (cashToClosePaid) {
      setPayloadCompleteNoAmountRemainingOpen(true)
    } else {
      setPayloadCompleteAmountRemainingOpen(true)
    }
  }


  return (
    <Box my={2}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Box mb={2}><CashToCloseForm/></Box>
        <LoadingButton
          variant="text"
          sx={{
            borderRadius: "40px",
            minWidth: "250px",
            mt: 1,
          }}
          onClick={onUserSelfCompleteTask}
        >
          Complete {TaskText} 
        </LoadingButton>
      </Box>
      <CompletePayloadTaskNoAmountRemainingDialog
        open={payloadCompleteNoAmountRemainingOpen}
        setUserCompleteOpen={setPayloadCompleteNoAmountRemainingOpen}
        onUserCompleteTask={onUserCompleteTask}
      />
      <CompletePayloadTaskAmountRemainingDialog
        open={payloadCompleteAmountRemainingOpen}
        setUserCompleteOpen={setPayloadCompleteAmountRemainingOpen}
        onUserCompleteTask={onUserCompleteTask}
      />

      <CompletePayloadTaskNoAmountSpecified
        open={payloadCompleteNoAmountSpecifiedOpen}
        setUserCompleteOpen={setPayloadCompleteNoAmountSpecifiedOpen}
        onUserCompleteTask={onUserCompleteTask}
      />
    </Box>
  )
}

